import React, { FC } from 'react';
import { Box, styled, Typography, useTheme } from '@mui/material';
import useShopifyMenuSWR from '../../../../hooks/shopify/useShopifyMenuSWR';
import { NavigationMenuItem } from '../../../../models/NavigationMenuItem';
import { Link } from 'react-router-dom';
import { getCollectionHandle } from '../../../../utils/utils';
import { FooterTitle } from '../../../styled/Footer/FooterTitle';
import { FooterItemContentStyle } from '../../../styled/Footer/FooterItemContentStyle';
import { useTranslation } from 'react-i18next';

const LinkWrapper = styled(Box)(({ theme }) => ({
    paddingBottom: '5px',
    'a, p': {
        color: 'white',
    },
}));

const TopFooterItemMenu: React.FC<any> = (props) => {
    const title = props.title;
    const collectionHandle = props.collectionHandle;
    const theme = useTheme();

    const { menuItems, isLoading, isError, forceRefresh } =
        useShopifyMenuSWR(collectionHandle);

    const { t } = useTranslation();

    const getLink = (item) => {
        return (
            <a href={item.url}>
                <Typography>{item.title}</Typography>
            </a>
        );
        // if (item.type == 'COLLECTION') {
        //     return (
        //         <Link to={'collections/' + getCollectionHandle(item.url)}>
        //             <Typography>{item.title}</Typography>
        //         </Link>
        //     );
        // } else {
        //     return (
        //         <a href={item.url}>
        //             <Typography>{item.title}</Typography>
        //         </a>
        //     );
        // }
    };

    return (
        <Box>
            <FooterTitle>{t(title)}</FooterTitle>
            <FooterItemContentStyle>
                {menuItems &&
                    menuItems.items.length > 0 &&
                    menuItems.items.map((item: NavigationMenuItem) => (
                        <LinkWrapper key={item.id}>{getLink(item)}</LinkWrapper>
                    ))}
            </FooterItemContentStyle>
        </Box>
    );
};

export default TopFooterItemMenu;
